<template>
  <v-expansion-panels class="mb-5">
    <v-expansion-panel v-for="(branch, index) in branches" :key="index">
      <v-expansion-panel-header class="no-padding d-flex px-1">
        <v-divider vertical />
        <div class="d-flex align-end pb-4">
          <div class="pl-5 mr-auto">
            <h6 class="body-2 grey--text text--darken-2">
              <span class="d-block grey--text font-weight-bold caption mt-2">
                {{ $t('hausefulInvoices.subsidiary') }}
              </span>
              {{ branch.name }}
            </h6>
          </div>
          <div class="text-right mx-3">
            <h5 class="d-block body-2 success--text">
              <span class="d-block grey--text font-weight-bold caption mt-2">
                {{ $t('hausefulInvoices.total') }}
              </span>
              {{ totalAmount(branch.total) }}
            </h5>
          </div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="no-padding">
        <HostInvoiceTable :branch="branch" />
      </v-expansion-panel-content>
      <v-divider class="ml-1" />
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import HostInvoiceTable from './HostInvoiceTable'
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'HausefulInvoiceBranch',

  props: {
    branches: {
      type: Object,
      required: true,
    },
  },

  components: {
    HostInvoiceTable,
  },

  methods: {
    totalAmount(amount) {
      return catalogMonetary(amount ?? 0.00)
    },
  }
}
</script>
